import { toNumber, uniq } from 'lodash-es'
import { roofStoreyKey } from '@editorStores'
import { ElementListItem } from '../types'

/** Human label for a storey id, matching the conventions used elsewhere (EG / n. OG / Dach). */
export const storeyToLabel = (storey: string): string => {
  if (storey === '0') return 'EG'
  if (storey === roofStoreyKey) return 'Dach'
  return `${storey}. OG`
}

/** Storeys present across the given items, sorted bottom-to-top with the roof last. */
export const collectStoreys = (itemsByElementType: Record<string, ElementListItem[]>): string[] => {
  const storeys = uniq(
    Object.values(itemsByElementType)
      .flat()
      .map(item => item.storey)
      .filter((storey): storey is string => !!storey),
  )
  return storeys.sort((a, b) => {
    const aN = a === roofStoreyKey ? Number.MAX_SAFE_INTEGER : toNumber(a)
    const bN = b === roofStoreyKey ? Number.MAX_SAFE_INTEGER : toNumber(b)
    return aN - bN
  })
}
